import React from "react";
import ServiceTemplate from "../../components/templates/ServiceTemplate";
import lifeBg from "../../assets/images/produtos/vida.webp";

const LifeInsurance = () => {
  const serviceData = {
    heroImage: lifeBg,
    title: "Seguro de Vida",
    artigo: "um",
    subtitle:
      "Garanta o futuro de quem você ama com proteção financeira e tranquilidade",
    color: "purple",
    icon: "heart",
    ramo: "Vida",
    pageRamo: true,
    showEmail: true,
    showVeiculo: false,
    formUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLScQc-SPygWVNQn0Zl1IUIqvtMl73Xa1sa_6qW7IaBalG3J5Ug/formResponse",
    mainContent: [
      "O seguro de vida é uma forma de garantir proteção financeira para sua família em momentos difíceis. Com um seguro de vida da Free Market Seguros, você tem a tranquilidade de saber que seus entes queridos estarão amparados financeiramente caso algo aconteça com você.",
      "Trabalhamos com as principais seguradoras do mercado para oferecer a você as melhores coberturas com preços acessíveis, garantindo proteção adequada às necessidades da sua família.",
    ],
    coverages: [
      "Morte natural ou acidental",
      "Invalidez permanente total ou parcial por acidente",
      "Assistência funeral",
      "Doenças graves",
      "Diárias por incapacidade temporária",
    ],
    additionalCoverages: [
      "Invalidez funcional permanente por doença",
      "Doenças graves ampliadas",
      "Diárias de internação hospitalar",
      "Assistência médica domiciliar",
      "Serviços de telemedicina",
    ],
    advantages: [
      {
        icon: "shield-alt",
        title: "Proteção Familiar",
        description:
          "Garantia de suporte financeiro para sua família em momentos difíceis",
      },
      {
        icon: "hand-holding-heart",
        title: "Tranquilidade",
        description:
          "Segurança de saber que seus entes queridos estarão amparados",
      },
      {
        icon: "file-medical",
        title: "Coberturas Flexíveis",
        description:
          "Opções personalizadas de acordo com suas necessidades e orçamento",
      },
    ],
    steps: [
      {
        title: "Análise de Necessidades",
        description:
          "Avaliamos seu perfil familiar, responsabilidades financeiras e objetivos de proteção.",
      },
      {
        title: "Apresentação de Opções",
        description:
          "Apresentamos as melhores opções de seguradoras e coberturas para seu perfil e necessidades.",
      },
      {
        title: "Contratação Simplificada",
        description:
          "Após escolher o plano ideal, cuidamos de toda a documentação e processo de contratação.",
      },
      {
        title: "Suporte Contínuo",
        description:
          "Oferecemos assistência durante toda a vigência da apólice e especialmente em momentos de sinistro.",
      },
    ],
    tip: "Ao contratar um seguro de vida, considere não apenas o valor da indenização por morte, mas também coberturas adicionais como invalidez e doenças graves, que podem proteger você e sua família em diversas situações. O ideal é que o capital segurado seja suficiente para cobrir pelo menos 5 anos das despesas familiares.",
  };

  return <ServiceTemplate {...serviceData} />;
};

export default LifeInsurance;
